import type { SearchObjectFieldsTypeFromMappingObjectType } from './types'
import { publicTemplatesMapping } from '../indexMappings/publicTemplates'

type SearchPublicTemplatesFields = SearchObjectFieldsTypeFromMappingObjectType<
  typeof publicTemplatesMapping
>

export type SearchPublicTemplatesRequiredFields = Required<{
  [K in keyof Pick<
    SearchPublicTemplatesFields,
    | 'title'
    | 'description'
    | 'noteId'
    | 'organizationDomain'
    | 'organizationId'
    | 'parentNoteIdList'
  >]: SearchPublicTemplatesFields[K]
}>

// Only used to have type safety and SEARCH_PUBLIC_TEMPLATES_REQUIRED_FIELDS matching SearchPublicTemplatesRequiredFields type definition
const searchPublicTemplatesRequiredFieldsHelper: {
  [K in keyof SearchPublicTemplatesRequiredFields]: true
} = {
  description: true,
  noteId: true,
  organizationDomain: true,
  organizationId: true,
  parentNoteIdList: true,
  title: true,
}

export const SEARCH_PUBLIC_TEMPLATES_REQUIRED_FIELDS = Object.freeze(
  Object.keys(searchPublicTemplatesRequiredFieldsHelper)
)

export type SuggestPublicTemplateResult = {
  title: string
  description: string
  noteId: string
  organizationDomain: string
  organizationId: string
  parentNoteIdList: string[]
  score: number
}
